export default __webpack_public_path__ + "static/media/back-to-top.2fa04c45.svg";